/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {BaseHttpRequest} from './core/BaseHttpRequest';
import type {OpenAPIConfig} from './core/OpenAPI';
import {AxiosHttpRequest} from './core/AxiosHttpRequest';
import {AiAdminService} from './services/AiAdminService';
import {AiTransactionService} from './services/AiTransactionService';
import {AuthService} from './services/AuthService';
import {EntitlementsService} from './services/EntitlementsService';
import {FeedbackService} from './services/FeedbackService';
import {HealthService} from './services/HealthService';
import {InternalEntitlementsService} from './services/InternalEntitlementsService';
import {OpenFeatureService} from './services/OpenFeatureService';
import {QcOutputDocumentTypeInternalService} from './services/QcOutputDocumentTypeInternalService';
import {QcTriggerConfigInternalService} from './services/QcTriggerConfigInternalService';
import {QcUnsignedPackageDocumentTypeInternalService} from './services/QcUnsignedPackageDocumentTypeInternalService';
import {SupportAssistantQuestionService} from './services/SupportAssistantQuestionService';
import {UsageStatsService} from './services/UsageStatsService';
import {VersionService} from './services/VersionService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class EntitlementsApiService {
  public readonly aiAdmin: AiAdminService;
  public readonly aiTransaction: AiTransactionService;
  public readonly auth: AuthService;
  public readonly entitlements: EntitlementsService;
  public readonly feedback: FeedbackService;
  public readonly health: HealthService;
  public readonly internalEntitlements: InternalEntitlementsService;
  public readonly openFeature: OpenFeatureService;
  public readonly qcOutputDocumentTypeInternal: QcOutputDocumentTypeInternalService;
  public readonly qcTriggerConfigInternal: QcTriggerConfigInternalService;
  public readonly qcUnsignedPackageDocumentTypeInternal: QcUnsignedPackageDocumentTypeInternalService;
  public readonly supportAssistantQuestion: SupportAssistantQuestionService;
  public readonly usageStats: UsageStatsService;
  public readonly version: VersionService;
  public readonly request: BaseHttpRequest;
  constructor(
    config?: Partial<OpenAPIConfig>,
    HttpRequest: HttpRequestConstructor = AxiosHttpRequest,
  ) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? '1',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.aiAdmin = new AiAdminService(this.request);
    this.aiTransaction = new AiTransactionService(this.request);
    this.auth = new AuthService(this.request);
    this.entitlements = new EntitlementsService(this.request);
    this.feedback = new FeedbackService(this.request);
    this.health = new HealthService(this.request);
    this.internalEntitlements = new InternalEntitlementsService(this.request);
    this.openFeature = new OpenFeatureService(this.request);
    this.qcOutputDocumentTypeInternal = new QcOutputDocumentTypeInternalService(
      this.request,
    );
    this.qcTriggerConfigInternal = new QcTriggerConfigInternalService(
      this.request,
    );
    this.qcUnsignedPackageDocumentTypeInternal =
      new QcUnsignedPackageDocumentTypeInternalService(this.request);
    this.supportAssistantQuestion = new SupportAssistantQuestionService(
      this.request,
    );
    this.usageStats = new UsageStatsService(this.request);
    this.version = new VersionService(this.request);
  }
}
